// extracted by mini-css-extract-plugin
export var document = "Document-module--document--qDpUP";
export var container = "Document-module--container--24lx3";